module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": require("../../assets/posters/hondurasMinistries.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Honduras Ministries")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2016")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional/Mini-Documentary")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Honduras Ministries exists to nurture the spiritual and physical needs of the people of Honduras through education, a unique child enrichment program, and rural community development. They operate in the ultra-poor communities throughout rural Honduras; communities that are forgotten, ignored, and abandoned by their government. The people of these communities live on less than $1.50 a day and are among the most impoverished people in the world. Honduras currently ranks as the fourth poorest country in the western hemisphere. Starvation, death from disease, and human trafficking are just some of the realities the people in these communities deal with on a daily basis. Honduras Ministries believes that through their partnership with the local church, they can make a difference.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": require("../../assets/projects/honduras-ministries/hondurasMinistriesTestimonial.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("John Beddall")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Honduras Ministries")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Working with Famous King was an amazing experience from start to finish. Derek’s creativity and passion for his art form showed in every aspect of production. Being able to work with Famous King has given our ministry a wonderful tool that has already aided us in fundraising and exposing partnering organizations to our ministry. We will, without a doubt, be working with them again soon!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88c75238"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/HondurasMinistries.vue
// module id = 80
// module chunks = 0